// Email validation
export function validateEmail(email: string): boolean {
  const trimmedEmail = email.trim();
  // Basic email validation that accepts test domains
  if (!trimmedEmail || trimmedEmail.length > 254) return false;
  const parts = trimmedEmail.split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  // Check local part
  if (!local || local.length > 64) return false;
  // Check domain part
  if (!domain || domain.length > 255) return false;
  if (!domain.includes('.')) return false;
  return true;
}

// Password validation
export function validatePassword(password: string): boolean {
  return password.length >= 8;
}

// Full name validation
export function validateFullName(name: string): boolean {
  const trimmedName = name.trim();
  const nameRegex = /^[a-zA-Z\s-]{2,50}$/;
  return nameRegex.test(trimmedName) && trimmedName.length >= 2;
}

// Website URL normalization
export function normalizeWebsiteUrl(url: string): string {
  url = url.trim();
  if (!url) return '';

  try {
    // Handle simple domain input
    if (!url.includes('://')) {
      return url.toLowerCase().replace(/^www\./i, '');
    }
    // Handle full URLs
    const urlObj = new URL(url.toLowerCase());
    return urlObj.hostname.replace(/^www\./i, '');
  } catch (error) {
    // If URL is invalid, return empty string
    return '';
  }
}